import {
  ApplicationService,
  IApplicationGetFilters,
} from '@/app/services/applications'
import {
  ErrorResponse,
  IPaginationParams,
  PaginatedQueryResponse,
} from '@/types/api'
import { IApplication } from '@/types/application'
import { useQuery, UseQueryOptions } from 'react-query'

export function useApplications(
  filters: IApplicationGetFilters = {},
  pagination: IPaginationParams = {},
  options?: Omit<
    UseQueryOptions<PaginatedQueryResponse<IApplication>, ErrorResponse>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery<PaginatedQueryResponse<IApplication>, ErrorResponse>(
    [ApplicationService.GET_PATH, filters, pagination],
    () => ApplicationService.getApplications(filters, pagination),
    options
  )
}
